import FileSaver from 'file-saver'

import { config } from '../config'
import { momentDateHandler } from '../date/moment-date-handler'

const { formatDate, newDate } = momentDateHandler

export const fileTypes = {
  csv: { mimeType: 'application/csv', extension: 'csv' },
  pdf: { mimeType: 'application/pdf', extension: 'pdf' },
  xlsx: {
    mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    extension: 'xlsx',
  },
}

export const saveFileAs = ({ content, name, fileType = 'pdf' }) => {
  const blobFile = new Blob([content], { type: fileTypes[fileType].mimeType })
  const fileName = `${name}.${fileTypes[fileType].extension}`

  return FileSaver.saveAs(blobFile, fileName)
}

export const generateFileName = ({ prefix, from, to }: { prefix: string; from: Date; to: Date }) => {
  const fromDate = formatDate({ date: newDate(from), format: config.fileNameFormat })
  const toDate = formatDate({ date: newDate(to), format: config.fileNameFormat })

  return `${prefix}-from-${fromDate}-to-${toDate}`
}
